import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ShowCombinedReportsResolver } from '../../combined-reports/show-combined-reports.resolver';
import { DashboardService } from '../../dashboard/dashboard.service';
import { CfdService } from '../../device-management/cfd/cfd.service';
import { KitchenGuard } from '../../device-management/kitchen/guard/kitchen-guard';
import { FloorService } from '../../floors/services/floor.service';
import { PaymentAccountService } from '../../payments/payment-account/payment-account.service';
import { PaymentsService } from '../../payments/payments.service';
import { PaymentProcessingResolver } from '../../payments/resolvers/payment-processing.resolver';
import { PaymentProcessorResolver } from '../../payments/resolvers/payment-processors.resolver';
import { PaymentTerminalsResolver } from '../../payments/resolvers/payment-terminals.resolver';
import { ProductConverterService } from '../../products/product-converter.service';
import { ProductsPermissionResolver } from '../../products/products-permission.resolver';
import { ProductsService } from '../../products/products.service';
import { AllowIrsReportingResolver } from '../../reports/allow-irs-reporting.resolver';
import { ClosingReportService } from '../../reports/closing-report/closing-report.service';
import { ClosingReportGuard } from '../../reports/closing-report/guards/closing-report.guard';
import { ClosingReportResolver } from '../../reports/closing-report/resolvers/closing-report.resolver';
import { ReportsPermissionGuard } from '../../reports/reports-permission.guard';
import { ReportsPermissionResolver } from '../../reports/reports-permission.resolver';
import { AccessGuard } from '../../shared/guards/access-guard';
import { ShowDeviceLogsResolver } from '../../support/support-device-logs/show-device-logs-resolver';
import { SidebarButtonModule } from '../components/buttons/ls-sidebar-button/sidebar-button.module';
import { ComponentsModule } from '../components/components.module';
import { FlashModule } from '../components/flash/flash.module';
import { ModalService } from '../components/modal/modal.service';
import { DynamicTranslationModule } from '../dynamic-translation/dynamic-translation.module';
import { RestService } from '../http/rest.service';
import { ReportsService } from '../reports/reports.service';
import { AccessControlService } from './access-control.service';
import { AlwaysShowRouteResolver } from './always-show-route-resolver';
import { NavigationService } from './navigation.service';
import { BreadcrumbComponent } from './subnavigation/containers/breadcrumb.component';
import { PageComponent } from './subnavigation/containers/page.component';

@NgModule({
  imports: [
    CommonModule,
    DynamicTranslationModule,
    SidebarButtonModule,
    FlashModule,
    ComponentsModule,
    RouterModule.forChild([])
  ],
  declarations: [BreadcrumbComponent, PageComponent],
  providers: [
    NavigationService,
    AccessControlService,
    RestService,
    ReportsService,
    FloorService,
    PaymentsService,
    ProductConverterService,
    ReportsPermissionResolver,
    ShowCombinedReportsResolver,
    ProductsPermissionResolver,
    ShowDeviceLogsResolver,
    AlwaysShowRouteResolver,
    AllowIrsReportingResolver,
    ClosingReportResolver,
    ReportsPermissionGuard,
    ClosingReportGuard,
    AccessGuard,
    KitchenGuard,
    PaymentProcessingResolver,
    PaymentProcessorResolver,
    PaymentTerminalsResolver
  ],
  exports: [BreadcrumbComponent, PageComponent]
})
export class NavigationModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: NavigationModule,
      providers: [
        ProductsService,
        ModalService,
        DashboardService,
        CfdService,
        ClosingReportService,
        PaymentAccountService
      ]
    };
  }
}
